import { FlightCard, Sectors, TransitVisaRequest, TransitVisaSegment } from '@/src/types/flight'
import { convertDDMMYYYYToISO } from '@/src/utils/date/convertDateFormat'

const toIso = (date: string, time: string): string => `${convertDDMMYYYYToISO(date)}T${time}:00+00:00`

const buildSegments = (sectorKey: string | undefined, sectors: Sectors): TransitVisaSegment[] => {
    if (!sectorKey) return []
    const segments = sectors[sectorKey]?.flights?.segments
    if (!segments) return []
    return segments.map(segment => ({
        dep: segment.departure.airportCode,
        arr: segment.arrival.airportCode,
        ddt: toIso(segment.departure.date, segment.departure.time),
        adt: toIso(segment.arrival.date, segment.arrival.time)
    }))
}

// One request per journey side (never per layover): OW → 1, RT → 2 (onward + return), multicity → one per trip.
export const getTransitVisaRequests = (flights: FlightCard[], sectors: Sectors): TransitVisaRequest[] => {
    if (!flights?.length) return []

    const sectorKeys =
        flights.length === 2
            ? [flights[0]?.sectorKeys?.[0], flights[1]?.sectorKeys?.[0]]
            : (flights[0]?.sectorKeys ?? [])

    return sectorKeys
        .map(key => buildSegments(key, sectors))
        .filter(os => os.length > 0)
        .map(os => ({
            scfrom: os[0].dep,
            scto: os[os.length - 1].arr,
            jt: 'OW' as const,
            os,
            enableTvSegmentList: true
        }))
}
